"use strict";

import OrganizationRoutes from "./organization.routes";
import OrganizationNew from "../../views/Organization/OrganizationNew.vue";

export default {
  OrganizationNew: {
    path: "/organization/new",
    component: OrganizationNew,
    meta: {
      auth: true
    }
  },
  OrganizationRoutes
};
